module.exports = __webpack_public_path__ + "static/media/1_WEB_Sierre_Image_TEST.8ca47fc8.jpg";